import messages from '@/i18n';

export default {
  methods: {
    t(str, arg) {
      const libString = messages.global.t(str, arg);
      return this.$t && this.$te
        ? this.$te(str)
          ? this.$t(str)
          : libString
        : libString
          ? libString
          : str;
    },
    p(str) {
      return this.t('app.' + str);
    }
  },
  i18n: messages
};
